<div class="search-wrapper flex-1 flex-row align-start-center">

  <div class="search flex-row align-start-center">
    @if (!searchLoading) {
      <mat-icon>search</mat-icon>
    }
    @if (searchLoading) {
      <mat-spinner [diameter]="24" color="primary"></mat-spinner>
    }
    <input class="flex-1" placeholder="busca" matInput (focus)="onFocusSearch()"
      id="search-search"
      [formControl]="search"
      (focusout)="onFocusOutSearch()" #searchInput>
  </div>

</div>
@if (showSuggestions) {
  <ul class="suggestions">
    @for (subProject of subProjects; track subProject; let i = $index) {
      <li
        [ngClass]="[(i+1) === selectedItem ? 'active' : '']" (mousedown)="openSubProject(subProject.id!)">
        <mat-icon class="ballot">ballot</mat-icon>
        <div class="info">
          <div class="sugg-title">{{subProject.name}}</div>
          <span class="desc">
            <span class="text-uppercase mr-20">projeto</span>
            <span class="customer-name">{{subProject.customerGroupName}}</span>
          </span>
        </div>
        <code class="type" [hidden]="true">subProject</code>
        <code class="id" [hidden]="true">{{subProject.id}}</code>
      </li>
    }
    @for (remoteApp of remoteApps; track remoteApp; let i = $index) {
      <li
        [ngClass]="[(i+1+subProjects.length) === selectedItem ? ' active' : '']"
        (mousedown)="openRemoteApp(remoteApp.id!)">
        <img [src]="imageFileService.getRemoteAppPictureUrl(remoteApp.imageUUID, 64)" width="64"
          height="64">
        <div class="info">
          <div class="sugg-title">{{remoteApp.name}} - {{remoteApp.subProjectName}}</div>
          <span class="desc">
            <span class="text-uppercase mr-20">Aplicativo</span>
            <span class="customer-name">{{remoteApp.desktopServerHostname}} | {{remoteApp.subProjectName}} | {{remoteApp.customerGroupName}}</span>
          </span>
        </div>
        <code class="type" [hidden]="true">remoteApp</code>
        <code class="id" [hidden]="true">{{remoteApp.id}}</code>
      </li>
    }
    @for (desktopServer of desktopServers; track desktopServer; let i = $index) {
      <li
        [ngClass]="[(i+1+remoteApps.length+subProjects.length) === selectedItem ? ' active' : '']"
        (mousedown)="openDesktopServer(desktopServer.id!)">
        <div>
          <fa-icon class="s-16 mr-8 windows-icon" [icon]="faWindows"></fa-icon>
          <div class="info">
            <div class="sugg-title">{{desktopServer.hostname}}</div>
            <span class="desc">
              <span class="text-uppercase mr-20">servidor</span>
              <span class="customer-name">{{desktopServer.subProjectName}} | {{desktopServer.customerGroupName}}</span>
            </span>
          </div>
          <code class="type" [hidden]="true">desktopServer</code>
          <code class="id" [hidden]="true">{{desktopServer.id}}</code>
        </div>
      </li>
    }
    @for (linuxServer of linuxServers; track linuxServer; let i = $index) {
      <li
        [ngClass]="[(i+1+remoteApps.length+subProjects.length+desktopServers.length) === selectedItem ? 'active' : '']"
        (mousedown)="openLinuxServer(linuxServer.id!)">
        <fa-icon class="s-16 mr-8 linux-icon" [icon]="faLinux"></fa-icon>
        <div class="info">
          <div class="sugg-title">{{linuxServer.hostname}}</div>
          <span class="desc">
            <span class="text-uppercase mr-20">servidor</span>
            <span class="customer-name">{{linuxServer.subProjectName}} | {{linuxServer.customerGroupName}}</span>
          </span>
        </div>
        <code class="type" [hidden]="true">linuxServer</code>
        <code class="id" [hidden]="true">{{linuxServer.id}}</code>
      </li>
    }
    @for (managerUser of managerUsers; track managerUser; let i = $index) {
      <li
        id="search-manager-user-{{i}}"
        [ngClass]="[(i+1+remoteApps.length+subProjects.length+desktopServers.length+linuxServers.length) === selectedItem ? 'active' : '']"
        (mousedown)="openCustomerGroup(managerUser.customerGroupId!)">
        <fa-icon class="s-16 mr-8 linux-icon" [icon]="faUser"></fa-icon>
        <div class="info">
          <div class="sugg-title">{{managerUser?.email}}</div>
          <span class="desc">
            <span class="text-uppercase mr-20">Usuário</span>
            <span class="customer-name">{{managerUser?.displayName}} | {{managerUser.customerGroupName}}</span>
          </span>
        </div>
        <code class="type" [hidden]="true">managerUser</code>
        <code class="id" [hidden]="true">{{managerUser.customerGroupId}}</code>
      </li>
    }
    @for (customer of customers; track customer; let i = $index) {
      <li
        [ngClass]="[(i+1+remoteApps.length+subProjects.length+desktopServers.length+linuxServers.length+managerUsers.length) === selectedItem ? 'active' : '']"
        (mousedown)="openCustomerGroup(customer.customerGroupId!)">
        <fa-icon class="s-16 mr-8 linux-icon" [icon]="faBuilding"></fa-icon>
        <div class="info">
          <div class="sugg-title">{{customer.name}}</div>
          <span class="desc">
            <span class="customer-name">{{customer.cnpj}} | {{customer.customerGroupName}}</span>
          </span>
        </div>
        <code class="type" [hidden]="true">customer</code>
        <code class="id" [hidden]="true">{{customer.customerGroupId}}</code>
      </li>
    }
  </ul>
}
